<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12">
            <iq-card v-if="patient">
                <template v-slot:headerTitle>
                <h4 class="card-title">Owned sessions</h4>
                </template>
                <template v-slot:default>
                    <div v-if="patient.purchasedSessions">
                        You have {{  patient.purchasedSessions }}  sessions in balance.
                    </div>
                    <div v-else>
                        You have 0 sessions in balance.
                    </div>
                </template>
            </iq-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
            <iq-card>
                <template v-slot:headerTitle>
                <h4 class="card-title">Shop sessions</h4>
                </template>
                <template v-slot:default>
                    <PurchaseableSessions productType="sessions"></PurchaseableSessions>
                </template>
            </iq-card>
            </b-col>
      </b-row>
    </b-container>
</template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import getDocument from '../../services/getDocument'
import firebase from '../../../firebase'
import PurchaseableSessions from '../../components/Purchaseables.vue'

const body = document.getElementsByTagName('body')

export default {
  name: 'ShopSessions',
  components: { IqCard, PurchaseableSessions },
  setup () {
    const firebasePatient = firebase.firebaseAuth.currentUser
    const { document: patient } = getDocument('users', firebasePatient.uid)

    return {
      patient
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

    <style scoped>
      .profile-pic{
        height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
        margin: auto;
      }

      .profile-block {
        margin-top: 65px;
        margin-left: auto;
      }
    </style>
